import React from 'react'

import { Icon, HelpCircleIcon } from 'components/shared/Icon/Icon'
import { Tooltip } from 'components/shared/Tooltip/Tooltip'

import styles from './LabelWithTooltip.module.scss'
import cx from 'classnames'

export const LabelWithTooltip = ({
  children,
  icon = HelpCircleIcon,
  size = 16,
  tagName,
  tooltip,
  className,
}) => {
  const Element = tagName ?? 'h3'

  return (
    <Element className={cx(styles.heading, className)}>
      <span className={styles.label}>{children}</span>
      {tooltip ? (
        <Tooltip hasArrow>
          <Tooltip.Anchor className={styles.anchor}>
            <Icon className={styles.icon} {...{ icon, size }} />
          </Tooltip.Anchor>
          <Tooltip.Note note={tooltip} />
        </Tooltip>
      ) : null}
    </Element>
  )
}
